module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="body__header">\n		<div class="body-header__title">'+
((__t=( obj.title ))==null?'':__t)+
'</div>\n		<div class="body-header__options">\n\n			<div class="page-header__options">\n				';
 _.forEach(obj.buttons, function(button) { 
__p+='\n					<a class="'+
((__t=( getConditionalStr(button.icon, 'm-btn-icon', 'm-btn') ))==null?'':__t)+
' '+
((__t=( getConditionalStr(button.primary, 'm-btn--primary','') ))==null?'':__t)+
' m-btn--'+
((__t=( button.slug ))==null?'':__t)+
' js-button" role="button" data-action="'+
((__t=( button.action ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n				';
 }) 
__p+='\n			</div>\n\n		</div>\n	</div>\n\n\n<div class="body__content list-region">\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/page-body-view/templates/layout.html
// module id = 411
// module chunks = 0